import { format } from "date-fns";
import { es } from "date-fns/locale";

const CALENDAR_DATE_FORMAT = "dd/MM/yyyy";
const CALENDAR_TIME_FORMAT = "HH:mm";

/**
 * Formats a calendar date for WhatsApp messages (dd/MM/yyyy)
 */
export const formatCalendarDateLabel = (date: Date): string =>
  format(date, CALENDAR_DATE_FORMAT, { locale: es });

/**
 * Formats a calendar time for WhatsApp messages (HH:mm)
 */
export const formatCalendarTimeLabel = (date: Date): string =>
  format(date, CALENDAR_TIME_FORMAT, { locale: es });

/**
 * Formats a calendar selection range (dd/MM/yyyy de HH:mm a HH:mm)
 */
export const formatCalendarRangeLabel = (start: Date, end: Date): string => {
  const dateLabel = formatCalendarDateLabel(start);
  const startTime = formatCalendarTimeLabel(start);
  const endTime = formatCalendarTimeLabel(end);

  return `${dateLabel} de ${startTime} a ${endTime}`;
};

/**
 * Builds a WhatsApp message for a space reservation inquiry
 */
export const buildSpaceReservationWhatsAppMessage = (
  spaceName: string,
  start: Date,
  end: Date,
): string => {
  const rangeLabel = formatCalendarRangeLabel(start, end);

  return `Hola ${spaceName}! Me gustaría reservar sala desde ${rangeLabel}. ¿Podrías confirmarme si está disponible? Es para un ensayo.`;
};

/**
 * WhatsApp message after a public booking request is submitted
 */
export const buildPublicBookingSuccessWhatsAppMessage = (
  start: Date,
  end: Date,
  name: string,
): string => {
  const rangeLabel = formatCalendarRangeLabel(start, end);

  return `Hola! Soy ${name} Acabo de hacer una pre-reserva por el calendario de su página. Para el ${rangeLabel}. Quedo a la espera de confirmación de disponibildad y costos 🙌🏻`;
};

/**
 * WhatsApp message when staff contacts a booking requester
 */
export const buildManagerBookingContactWhatsAppMessage = (
  spaceName: string,
  name: string,
  startsAt: Date,
): string => {
  const dateLabel = formatCalendarDateLabel(startsAt);

  return `Hola ${name}! nos comunicamos desde ${spaceName} por tu reserva del ${dateLabel}`;
};
